import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { TableColumn, DateTableColumn, TableComponent, DataReloadEvent, LoginService } from '@serengeti/serengeti-common';
import { SchedulerService } from '../service/scheduler.service';
import { TranslateService } from '@ngx-translate/core';
import { Router, RouterEvent, NavigationEnd } from '@angular/router';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { MatDatepicker } from '@angular/material/datepicker';
import { SchedulerCalendarComponent } from '../calendar/calendar.component';

@Component({
  selector: 'app-service-scheduler-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.scss']
})
export class SchedulerListComponent implements OnInit {

	columns: TableColumn[];

	_searchControl: ElementRef;
	@ViewChild('search', { static: false }) set searchControl(_searchControl: ElementRef) {
		this._searchControl = _searchControl;
		if (_searchControl) {
			_searchControl.nativeElement.addEventListener('keypress', (e: KeyboardEvent) => {
				if (e.key === "Enter") {
					this.doSearch();
				}
			});
		}
	}
	get searchControl() {
		return this._searchControl;
	}
	oldSearchName: string;

	_schedulerList: TableComponent;
	@ViewChild('schedulerList', {static: false}) set schedulerList(_schedulerList: TableComponent) {
		if (this._schedulerList !== _schedulerList) {
			this._schedulerList = _schedulerList;

			this.doSearch();	
		}
	}
	get schedulerList(): TableComponent {
		return this._schedulerList;
	}

	currentCondition: DataReloadEvent;
	searchName: string;

	dateSelected: Date;
	viewFormat: string;
	
	selectedIndex = 0;
	schedules: any[];

	@ViewChild('selectPicker', {static: false}) datePicker: MatDatepicker<Date>;

	@ViewChild('scheduleCalendar', {static: false}) scheduleCalendar: SchedulerCalendarComponent;

	routeSubscription: Subscription;

	constructor(
		private router: Router,
		private schedulerService: SchedulerService,
		private translateService: TranslateService,
		private loginService: LoginService
	) {
		this.columns = [
			new TableColumn('name', 'service.scheduler.list.content.columns.name'),
			new TableColumn('state', 'service.scheduler.list.content.columns.state'),
			new DateTableColumn('createdDate', 'service.scheduler.list.content.columns.created-date'),
			new DateTableColumn('updatedDate', 'service.scheduler.list.content.columns.updated-date')
		];

		this.dateSelected = new Date();

		this.selectedIndex = 0;
		this.routeSubscription = this.router.events.pipe(
			filter((event: RouterEvent) => event instanceof NavigationEnd)
		).subscribe(() => {
			this.doInit();
		});
	}

	ngOnInit() {
	}

	ngOnDestroy() {
		if (this.routeSubscription) {
			this.routeSubscription.unsubscribe();
		}
	}

	doInit() {
		this.selectedIndex = this.loginService.getScreenConfig('scheduler-list', 'tabIndex', 0);
		this.viewFormat = this.loginService.getScreenConfig('scheduler-list', 'view', "Month");
		this.dateSelected = this.loginService.getScreenConfig('scheduler-list', 'date', new Date());

		if (this.dateSelected) {
			this.dateSelected = new Date(this.dateSelected);
		}
		this.doSearch();
	}

	onTabChange() {
		this.loginService.setScreenConfig('scheduler-list', 'tabIndex', this.selectedIndex);

		if (this.selectedIndex == 0) {
			this.scheduleCalendar.onDaysResized();
		}
	}

	doSearch() {
		if (this.oldSearchName && this.searchName === this.oldSearchName) {
			return;
		}

		if (this.schedulerList) {
			const sortItem = this.loginService.getScreenConfig('scheduler.list', 'sortItem');
			const sortOrder = this.loginService.getScreenConfig('scheduler.list', 'sortOrder');

			this.oldSearchName = this.searchName;
			this.doRefresh(new DataReloadEvent((sortItem ? sortItem : 'updatedDate'), (sortOrder ? sortOrder : 'desc'),
				0, this.schedulerList.pageSize, this.searchName));
		}
	}

	doRefresh(condition?: DataReloadEvent) {
		if (condition) {
			this.currentCondition = condition;
		} else {
			condition = this.currentCondition;
		}

		if (condition.pageNumber === 0) {
			this.loginService.setScreenConfig('scheduler.list', 'sortItem', condition.active);
			this.loginService.setScreenConfig('scheduler.list', 'sortOrder', condition.sortOrder);
		}

		this.schedulerService.search(condition.filter, condition.active, condition.sortOrder, condition.pageNumber, condition.pageSize)
			.subscribe(resultPage => {
			this.schedulerList.refresh(resultPage.totalElements, resultPage.content, this.columns, condition);

			this.schedules = resultPage.content;
		});
	}

	goCreate() {
		this.router.navigate(['/main', { outlets: { content: 'service/scheduler/create' }}]);
	}

	goDetail($event: any) {
		const scheduler = $event.element.getData();

		this.onScheduler(scheduler);
	}

	onDateChanged(selectedDate: Date) {
		if (!this.dateSelected || !(selectedDate.getFullYear() === this.dateSelected.getFullYear()
		&& selectedDate.getMonth() === this.dateSelected.getMonth()
		&& selectedDate.getDate() === this.dateSelected.getDate())) {
			this.dateSelected = selectedDate;
			this.loginService.setScreenConfig('scheduler-list', 'date', selectedDate);
		}
	}

	onViewChanged(viewFormat: string) {
		if (viewFormat !== this.viewFormat) {
			this.viewFormat = viewFormat;
			this.loginService.setScreenConfig('scheduler-list', 'view', viewFormat);
		}
	}

	onScheduler(scheduler: any) {
		if (scheduler.taskHistoryId) {
			this.router.navigate(['/main', { outlets: { content: 'service/scheduler/detail/' + scheduler.id + '/' }}], { queryParams: { taskHistoryId: scheduler.taskHistoryId }});
		} else {
			this.router.navigate(['/main', { outlets: { content: 'service/scheduler/detail/' + scheduler.id + '/' }}]);
		}
	}

}
